(() => {
  if (window.teFilterDialogLoaded) return;
  window.teFilterDialogLoaded = true;
  const controllers = new WeakMap();
  const releasedDialogs = new WeakSet();
  const releaseDialog = dialog => {
    if (!dialog || releasedDialogs.has(dialog)) return;
    releasedDialogs.add(dialog);
    const root = dialog.closest('[data-section-id]');
    const trigger = root?.querySelector('[data-toggle-filters]');
    document.body.classList.remove('te-filter-open');
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus({ preventScroll:true });
  };
  const releaseClosedDialog = dialog => {
    requestAnimationFrame(() => {
      if (!dialog.isConnected || !dialog.open) releaseDialog(dialog);
    });
  };
  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-te-filter-dialog]')) releaseDialog(event.target);
  }, true);
  document.addEventListener('cancel', event => {
    if (event.target.matches?.('[data-te-filter-dialog]')) releaseClosedDialog(event.target);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dialog = document.querySelector('[data-te-filter-dialog][open]');
    if (dialog) releaseClosedDialog(dialog);
  }, true);
  const init = async (scope = document) => {
    await customElements.whenDefined('collection-filters');
    scope.querySelectorAll('[data-te-filter-dialog]').forEach(dialog => {
      const root = dialog.closest('[data-section-id]');
      const engine = dialog.querySelector('collection-filters');
      if (!root || !engine || controllers.has(root)) return;
      const trigger = root.querySelector('[data-toggle-filters]');
      const results = dialog.querySelector('[data-te-filter-results]');
      const reset = dialog.querySelector('[data-te-filter-reset]');
      const chips = root.querySelector('[data-te-active-filters]');
      let pending = false;
      let lastInputId;
      const disclosureState = new Map();
      engine.mobileFiltersScrollLock = () => {};
      engine.hideFiltersOnMobile = () => {};
      engine.showFiltersOnDesktop = () => {};
      const startLoading = engine.startLoading.bind(engine);
      engine.startLoading = function () {
        if (dialog.open) root.classList.add('is-loading');
        else startLoading();
      };
      const close = () => { if (dialog.open) dialog.close(); };
      const syncDisclosures = () => {
        const compact = window.matchMedia('(max-width: 767px)').matches;
        engine.querySelectorAll('[data-te-filter-disclosure]').forEach(disclosure => {
          const param = disclosure.closest('[data-te-filter-param]')?.dataset.teFilterParam;
          if (!param) return;
          if (disclosureState.has(param)) disclosure.open = disclosureState.get(param);
          else if (compact && param !== 'filter.p.m.custom.filtre_genre' && !disclosure.querySelector('input:checked')) disclosure.open = false;
        });
      };
      const sync = () => {
        syncDisclosures();
        const count = parseInt(root.querySelector('[data-products-count]')?.textContent.replace(/\s/g, ''), 10);
        if (Number.isFinite(count)) results.textContent = (count === 1 ? results.dataset.labelOne : results.dataset.labelOther).replace('__COUNT__', count);
        const nativeReset = engine.querySelector('.collection__filters__reset');
        if (nativeReset) reset.href = nativeReset.href;
        const active = engine.querySelector('[data-filters-reset]');
        chips.replaceChildren();
        if (active) [...active.children].forEach(child => {
          const clone = child.cloneNode(true);
          clone.removeAttribute('data-filter-reset-button');
          clone.setAttribute('data-te-active-filter', '');
          chips.append(clone);
        });
        if (!root.classList.contains('is-loading')) {
          pending = false;
          results.disabled = false;
          dialog.removeAttribute('aria-busy');
          if (dialog.open && lastInputId) {
            const input = [...engine.querySelectorAll('input')].find(item => item.id === lastInputId);
            input?.focus({ preventScroll:true });
            lastInputId = undefined;
          }
        }
      };
      const observer = new MutationObserver(sync);
      observer.observe(engine, { childList:true });
      observer.observe(root.querySelector('[data-products-count]'), { childList:true, subtree:true });
      observer.observe(root, { attributes:true, attributeFilter:['class'] });
      const onInput = event => {
        if (!engine.contains(event.target)) return;
        pending = true;
        lastInputId = event.target.id;
        results.disabled = true;
        dialog.setAttribute('aria-busy', 'true');
      };
      const onClick = event => {
        const summary = event.target.closest('.te-filter-group-title');
        if (summary && dialog.contains(summary)) {
          const disclosure = summary.closest('[data-te-filter-disclosure]');
          const param = disclosure?.closest('[data-te-filter-param]')?.dataset.teFilterParam;
          if (param) disclosureState.set(param, !disclosure.open);
        }
        const button = event.target.closest('[data-toggle-filters]');
        if (button && root.contains(button)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          releasedDialogs.delete(dialog);
          dialog.showModal();
          syncDisclosures();
          document.body.classList.add('te-filter-open');
          trigger?.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(() => dialog.querySelectorAll('range-slider').forEach(range => range.handleResize?.()));
        } else if (event.target.closest('[data-te-filter-reset]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          pending = true;
          results.disabled = true;
          engine.renderSection(new URL(reset.href).searchParams.toString());
        } else if (event.target.closest('[data-te-filter-close]') || event.target.closest('[data-te-filter-results]')) {
          event.preventDefault();
          if (!pending || event.target.closest('[data-te-filter-close]')) close();
        } else {
          const chip = event.target.closest('[data-te-active-filter]');
          if (chip) { event.preventDefault(); engine.renderSection(new URL(chip.href).searchParams.toString()); }
        }
      };
      root.addEventListener('click', onClick, true);
      dialog.addEventListener('input', onInput, true);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      });
      dialog.addEventListener('keydown', event => { if (event.key === 'Escape') event.stopPropagation(); });
      controllers.set(root, { destroy() { close(); observer.disconnect(); root.removeEventListener('click', onClick, true); } });
      sync();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => controllers.get(event.target)?.destroy());
})();
